<template>
    <div>
        机关文件
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>